import { Navigate } from 'react-router-dom';

import useAuthenticate from './authenticate';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuthenticate();

    if (!isAuthenticated && !isLoading) {
        console.log('User not authenticated, redirecting to login.');
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
